module.exports = __webpack_public_path__ + "static/img/1.92700a1f.jpg";